import t from './actionTypes'

const codeFormActions = {
	validateCodeForm(uid, value, resolve = () => {}, reject = () => {}) {
		return {
			type: t.CODE_FORM_SEND_SUBMITTED_CODE,
			uid,
			value,
			resolve,
			reject,
		}
	},
	resetCodeFormValidations(uid) {
		return {
			type: t.CODE_FORM_RESET,
			uid,
		}
	},
}

export default codeFormActions
